﻿window.HcStickyAtc = window.HcStickyAtc || {};

window.HcStickyAtc.init = (context = {}) => {
  const {
    section,
    addButton,
    addButtonLabel,
    priceElement,
    comparePriceElement,
    stickyQuantityInput,
    quantityInput,
    hasAmazonCustomizer,
    hasCustomizer = hasAmazonCustomizer,
    requiresCustomization = hasAmazonCustomizer,
    customizerConfigValid = true,
    customizerAppTarget,
    getCustomizerAction,
    syncQuantityValue
  } = context;

  if (!section || section.dataset.stickyAtcReady === 'true') return;
  section.dataset.stickyAtcReady = 'true';

    // Sticky ATC Logic
    const stickyATC = section.querySelector('[data-hc-sticky-atc]');
    const stickyBtn = section.querySelector('[data-hc-sticky-btn]');
    const stickyPrice = section.querySelector('[data-hc-sticky-price]');
    const stickyComparePrice = section.querySelector('[data-hc-sticky-compare-price]');
    const stickyImage = section.querySelector('[data-hc-sticky-image]');
    const stickyLabel = stickyBtn?.querySelector('span');
    const updateFloatingUi = () => {
      if (typeof window.__preaUpdateFloatingUi === 'function') {
        window.__preaUpdateFloatingUi();
      }
    };

    if (stickyATC && stickyBtn && (addButton || customizerAppTarget)) {
      const stickyUsesCustomizer = Boolean(hasCustomizer && requiresCustomization);
      const stickyTrigger = stickyUsesCustomizer ? customizerAppTarget : (addButton || customizerAppTarget);

      if (priceElement && stickyPrice) {
        const syncStickyPricing = () => {
          stickyPrice.innerHTML = priceElement.innerHTML;
          stickyPrice.classList.toggle('hc-sticky-atc__price--sale', priceElement.classList.contains('hc-price--sale'));
          if (comparePriceElement && stickyComparePrice) {
            stickyComparePrice.innerHTML = comparePriceElement.innerHTML;
            stickyComparePrice.hidden = comparePriceElement.hidden || !comparePriceElement.textContent.trim();
          }
        };
        const priceObserver = new MutationObserver(syncStickyPricing);
        priceObserver.observe(priceElement, { childList: true, characterData: true, subtree: true });
        if (comparePriceElement) {
          priceObserver.observe(comparePriceElement, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
        }
        syncStickyPricing();
      }

      if (stickyImage) {
        section.addEventListener('hc:variant-change', (event) => {
          const variant = event.detail?.variant;
          const imageUrl = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
          if (!imageUrl) return;
          stickyImage.src = imageUrl;
          stickyImage.removeAttribute('srcset');
        });
      }

      // Sync Button State (Loading and Disabled)
      if (addButton) {
        const btnObserver = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.attributeName === 'aria-busy') {
              if (addButton.getAttribute('aria-busy')) {
                stickyBtn.setAttribute('aria-busy', addButton.getAttribute('aria-busy'));
              } else {
                stickyBtn.removeAttribute('aria-busy');
              }
            }
            if (mutation.attributeName === 'disabled') {
              stickyBtn.disabled = addButton.disabled;
            }
          });
        });
        btnObserver.observe(addButton, { attributes: true, attributeFilter: ['aria-busy', 'disabled'] });
      }

      // Sync Button Text (ADD TO CART vs SOLD OUT)
      if (!stickyUsesCustomizer && addButtonLabel && stickyLabel) {
        const labelObserver = new MutationObserver(() => {
          stickyLabel.innerHTML = addButtonLabel.innerHTML;
        });
        labelObserver.observe(addButtonLabel, { childList: true, characterData: true, subtree: true });
      }

      if (stickyUsesCustomizer) {
        const syncCustomizerState = (event) => {
          const available = event?.detail?.available ?? (customizerAppTarget?.querySelector('.amzcustom-open')?.disabled === false);
          const action = getCustomizerAction?.();
          stickyBtn.disabled = !customizerConfigValid || !available || !action || action.disabled;
        };
        section.addEventListener('hc:customizer-context', syncCustomizerState);
        section.addEventListener('etsy-personalizer:ready', syncCustomizerState);
        window.setTimeout(() => syncCustomizerState(), 0);
      }

      let stickyDesiredVisible = false;
      let stickyUpdateQueued = false;
      const updateStickyVisibility = () => {
        const triggerRect = stickyTrigger.getBoundingClientRect();
        const triggerVisible = triggerRect.bottom > 0 && triggerRect.top < window.innerHeight;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        // Mobile shoppers need the action while the main button is still farther down the page.
        const mobileScrollThreshold = Math.min(160, window.innerHeight * 0.25);
        const shouldShow = isMobile
          ? window.scrollY > mobileScrollThreshold && !triggerVisible
          : triggerRect.bottom <= 0;

        if (shouldShow === stickyDesiredVisible) return;
        stickyDesiredVisible = shouldShow;

        if (shouldShow) {
          stickyATC.hidden = false;
          document.body.classList.add('has-sticky-atc');
          requestAnimationFrame(() => {
            if (!stickyDesiredVisible) return;
            stickyATC.classList.add('is-visible');
            updateFloatingUi();
            window.setTimeout(updateFloatingUi, 80);
          });
        } else {
          stickyATC.classList.remove('is-visible');
          document.body.classList.remove('has-sticky-atc');
          updateFloatingUi();
          window.setTimeout(() => {
            if (!stickyDesiredVisible) {
              stickyATC.hidden = true;
              updateFloatingUi();
            }
          }, 300);
        }
      };
      const queueStickyUpdate = () => {
        if (stickyUpdateQueued) return;
        stickyUpdateQueued = true;
        requestAnimationFrame(() => {
          stickyUpdateQueued = false;
          updateStickyVisibility();
        });
      };

      const stickyObserver = new IntersectionObserver(queueStickyUpdate, { threshold: 0 });
      stickyObserver.observe(stickyTrigger);
      window.addEventListener('scroll', queueStickyUpdate, { passive: true });
      window.addEventListener('resize', queueStickyUpdate);
      queueStickyUpdate();

      stickyBtn.addEventListener('click', () => {
        if (typeof syncQuantityValue === 'function') {
          syncQuantityValue(stickyQuantityInput?.value || quantityInput?.value);
        }

        if (!stickyUsesCustomizer && addButton) {
          addButton.click();
          return;
        }

        const customizerAction = getCustomizerAction();
        if (customizerAction) {
          customizerAction.click();
        } else {
          customizerAppTarget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
};

